"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortingOrder = exports.SortingField = void 0;
var SortingField;
(function (SortingField) {
    SortingField["SalesRank"] = "salesRank";
    SortingField["TargetGroupMen"] = "targetGroupMen";
    SortingField["TargetGroupWomen"] = "targetGroupWomen";
    SortingField["TargetGroupCouples"] = "targetGroupCouples";
    SortingField["Price"] = "price";
    SortingField["Distance"] = "distance";
    SortingField["Rating"] = "rating";
})(SortingField = exports.SortingField || (exports.SortingField = {}));
var SortingOrder;
(function (SortingOrder) {
    SortingOrder["Asc"] = "asc";
    SortingOrder["Desc"] = "desc";
})(SortingOrder = exports.SortingOrder || (exports.SortingOrder = {}));
//# sourceMappingURL=sorting.js.map